import AppPage from "../AppPage";
import MenuBottomBar, { MenuBarItem } from "../MenuBottomBar";
import { globals } from "../../styles";
import { arrow_Icon } from "../../assets/icons";
import LineupSelectionComponent from "../LineupSelectionComponent";
import LoadingSpinner from "../LoadingSpinner";
import { useCurrentPlayer } from "../../hooks/player";

function LineupSelectionPage(props: {
  handleNewLineup: (lineupIndex: number) => void;
  handleSelectLineup: (lineupIndex: number) => void;
  handleBackButton: () => void;
}) {
  const { handleNewLineup, handleSelectLineup, handleBackButton } = props;
  const { data: playerDetails, isPending } = useCurrentPlayer();

  return (
    <AppPage
      className={globals["page"]}
      bottomBar={
        <MenuBottomBar
          items={[
            MenuBarItem.Home,
            MenuBarItem.News,
            MenuBarItem.Leaderboards,
            MenuBarItem.Groups,
            MenuBarItem.LogOut,
          ]}
        />
      }
    >
      {isPending ? (
        <LoadingSpinner />
      ) : (
        <>
          <button
            className={`${globals["button-wrapper"]} ${globals["back-btn--top-left"]}`}
            onClick={handleBackButton}
          >
            <div className={globals["back-btn"]}>
              <img src={arrow_Icon} alt="" />
            </div>
          </button>
          <LineupSelectionComponent
            username={playerDetails?.username ?? ""}
            handleNewLineup={handleNewLineup}
            handleSelectLineup={handleSelectLineup}
          />
        </>
      )}
    </AppPage>
  );
}

export default LineupSelectionPage;
